import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@economic/taco';
import { useTruncated } from '../../hooks/useTruncated';

export const TruncatedElement = ({
    className,
    truncate = false,
    children,
    ...props
}: {
    className?: string;
    truncate?: boolean;
    children: JSX.Element;
}) => {
    const ref = React.useRef<HTMLSpanElement>(null);
    const { truncated } = useTruncated(ref.current, [children]);

    if (!truncate) {
        return children;
    }

    const element = (
        <span className={cn('truncate', className)} ref={ref} {...props}>
            {children}
        </span>
    );

    if (truncated) {
        return <Tooltip title={children}>{element}</Tooltip>;
    }

    return element;
};
